import { useTopPostsControls } from './useTopPostsControls.hook';
import DrawerSectionHeading from '../../DrawerSectionHeading';
import { InstagramIcon } from '../../Icons';
import InstagramSortableTopPosts from './InstagramSortableTopPosts';
import Stack from '../../Stack';
import TopPostsDownloadButton from '../TopPostsDownloadButton';
import { useCurrentCountry } from 'utils/hooks';
import useInstagramWeeks from 'utils/hooks/useInstagramWeeks';
import { useInstagramRelatedDrawerTopPosts } from 'utils/hooks/api';

// Used from the Pop Index drawer which flows TT weeks down — resolve IG weeks
// here so we hit the right keyword-matching IG snapshot.
function InstagramTopPostsDrawerRelatedAggregate({
    countryId,
    parentEntity,
    parentEntityId,
    relatedType,
    selectedId,
    displayQty = 5,
    name,
}) {
    const country = useCurrentCountry();
    const { week, year } = useInstagramWeeks();
    const {
        sortSelect,
        value,
        defaultSortOption,
        visibleOrderedMetrics,
        columnsMenu,
    } = useTopPostsControls({
        week,
        year,
        mixpanelContext: 'InstagramTopPostsSortSelect',
        tableName: 'instagram-pop-index-related-drawer',
    });

    const enabled = !!(countryId && selectedId && parentEntity && week && year);
    const topPostsQuery = useInstagramRelatedDrawerTopPosts({
        entity: relatedType,
        year: value.year,
        week: value.week,
        rank_type: value.apiRankType,
        countries: countryId ? [countryId] : null,
        categories: parentEntity?.type === 'category' ? [parentEntityId] : null,
        brands: parentEntity?.type === 'brand' ? [parentEntityId] : null,
        relatedCategories: relatedType === 'category' ? [selectedId] : null,
        relatedBrands: relatedType === 'brand' ? [selectedId] : null,
        enabled,
        per_page: 25,
    });

    return (
        <Stack $space="1rem">
            <DrawerSectionHeading>
                <span css="display: flex; align-items: center; gap: .5rem;">
                    <InstagramIcon />
                    Top Posts
                </span>
                <span css="margin-left: auto;">
                    <TopPostsDownloadButton
                        year={value.year}
                        week={value.week}
                        name={name}
                        country={country}
                        source="instagram"
                        topPostsQuery={topPostsQuery}
                        visibleOrderedMetrics={visibleOrderedMetrics}
                    />
                </span>
            </DrawerSectionHeading>
            <Stack
                css="display: flex; justify-content: space-between;"
                $space=".25rem"
                $direction="row"
            >
                {sortSelect}
                {columnsMenu}
            </Stack>
            <InstagramSortableTopPosts
                topPostsQuery={topPostsQuery}
                displayQty={displayQty}
                sortOption={defaultSortOption}
                visibleOrderedMetrics={visibleOrderedMetrics}
            />
        </Stack>
    );
}

export default InstagramTopPostsDrawerRelatedAggregate;
